<template>
  <div class="wrapper">
    <aside>
      <!-- 收藏菜单 -->
      <a-menu
        v-if="favoriteMenus?.childrenList?.length"
        class="favorite-menu"
        mode="inline"
        theme="dark"
        v-model:openKeys="favoriteOpenKeys"
        v-model:selectedKeys="favoriteSelectedKeys"
        @click="clickMenuItem($event, 'favorite')"
      >
        <sidebar-item :menu-info="favoriteMenus" />
      </a-menu>
      <a-menu
        mode="inline"
        theme="dark"
        v-model:openKeys="openKeys"
        v-model:selectedKeys="selectedKeys"
        @click="clickMenuItem($event, 'menu')"
      >
        <template v-for="item in menus" :key="String(item.id)">
          <sidebar-item
            :menu-info="item"
            :key="String(item.id)"
            v-if="item.menuType != 2 && item.childrenList"
          />
          <a-menu-item v-else :key="item.menuPath" :id="String(item.id)">
            <!-- 图标 -->
            <img
              :src="item.menuIcon"
              alt=""
              v-if="item.menuIcon"
              class="menuIcon"
            />
            <!-- <span>{{ item.menuName }}</span> -->
            <a-tooltip
              placement="right"
              color="#a7a7a7"
              :title="
                isEnglish && item.menuNameEn ? item.menuNameEn : item.menuName
              "
            >
              <span>{{
                isEnglish && item.menuNameEn ? item.menuNameEn : item.menuName
              }}</span>
            </a-tooltip>
          </a-menu-item>
        </template>
      </a-menu>
    </aside>
  </div>
</template>
<script>
import { reactive, toRefs, computed, watch, getCurrentInstance } from 'vue'
import { useRoute } from 'vue-router'
import SidebarItem from './SidebarItem'
import { useStore } from 'vuex'
// import { cupshe_GA } from 'cupshe-ga'
import { trackmMenuRank } from 'utils/track.js'
// import { getQueryString } from 'cupshe-utils'
// import _ from 'lodash'
export default {
  props: {
    collapsed: {
      type: Boolean
    }
  },
  components: {
    SidebarItem
  },
  setup() {
    const {
      proxy: { i18n }
    } = getCurrentInstance()
    // store对象
    const store = useStore()
    const route = useRoute()
    // 获取菜单
    const menus = computed(() => {
      const data = store.state.user.menus
      return data
    })

    // 收藏菜单
    const favoriteMenus = computed(() => {
      let data = store.state.user.favoriteMenus
      console.log('data:', data)
      if (data.length) {
        data = {
          id: 0,
          menuName: '我的收藏',
          menuNameEn: 'My Favorite',
          menuPath: '',
          menuType: 1,
          parentId: 0,
          childrenList: [...data]
        }
      } else {
        data = null
      }
      return data
    })

    const state = reactive({
      openKeys: [],
      selectedKeys: [],
      favoriteOpenKeys: [],
      favoriteSelectedKeys: [],
      storageKeys: [],
      systemId: null,
      lang: localStorage.getItem('lang'),
      isEnglish: i18n.global.locale !== 'zh-CN',
      clickType: '',
      // 监听菜单 触发埋点
      gaApi: item => {
        const { id, menuName } = item
        const { userName, userId } = store.state.user.userInfo
        // cupshe_GA(
        //   'click',
        //   {
        //     shop_id: '101',
        //     log_type: '2',
        //     event_category: 'click',
        //     event_name: 'btn_click',
        //     referer: window.history.state.back
        //   },
        //   {
        //     btn_id: 'PRO-' + id,
        //     btn_name: menuName + '',
        //     menu_name: menuName,
        //     menu_id: id,
        //     system_code: 'PRO',
        //     system_name: 'Portal统一登录系统',
        //     uname: userName,
        //     uid: userId,
        //     time: new Date()
        //   }
        // )
      }
    })
    /**
     * 根据当前的url查找出系统id，selectedId，openKeys
     * @param {*} path
     * @param {*} list
     */
    let idsMap = {
      systemId: '',
      openKeys: [],
      menuName: '',
      selectedKeys: []
    }
    const queryMenusIdByURL = (path, list, fullList) => {
      idsMap = {
        systemId: '',
        menuName: '',
        openKeys: [],
        selectedKeys: []
      }
      const item = list.find(item => {
        return item.menuPath === path
      })
      if (item) {
        idsMap.selectedKeys.push(item.menuPath)
        idsMap.menuName = item.menuName
        const parentId = item.parentId
        if (parentId === 0) {
          idsMap.systemId = item.id
        } else {
          deepQueryId(parentId, fullList || list)
        }
      }
      return idsMap
    }
    const deepQueryId = (id, list) => {
      idsMap.openKeys.push(String(id))
      const item = list.find(item => {
        return item.id === id
      })
      if (item) {
        const parentId = item.parentId
        if (parentId === 0) {
          idsMap.systemId = item.id
        } else {
          deepQueryId(parentId, list)
        }
      }
    }

    // 初始化默认选中的菜单
    const deepFindKeys = (path, type, saveToHistory = true) => {
      state.clickType = type || state.clickType
      const result = queryMenusIdByURL(
        decodeURIComponent(path),
        state.clickType === 'favorite'
          ? store.state.user.favoriteMenus
          : store.state.user.menuList,
        state.clickType === 'favorite' ? store.state.user.menuList : null
      )

      if (result && result.systemId > 0) {
        store.commit(
          'app/SET_OTHER_SYSTEM',
          {
            id: result.systemId,
            name: result.systemName,
            menuName: result.menuName
          },
          {
            root: true
          }
        )
      }
      if (result && result.selectedKeys.length) {
        if (
          !state.clickType &&
          store.state.user.favoriteMenus.find(
            item => item.parentId === result.openKeys[0]
          )
        ) {
          state.favoriteSelectedKeys = [...result.selectedKeys]
          state.favoriteOpenKeys = ['0', ...result.openKeys]
        } else {
          if (state.clickType === 'favorite') {
            state.favoriteSelectedKeys = [...result.selectedKeys]
            state.favoriteOpenKeys = ['0', ...result.openKeys]
            state.selectedKeys = []
            state.openKeys = []
          } else {
            state.selectedKeys = state.selectedKeys.concat(result.selectedKeys)
            state.openKeys = state.openKeys.concat(result.openKeys)
            state.favoriteSelectedKeys = []
            state.favoriteOpenKeys = []
          }
        }
        if (saveToHistory) {
          store.commit(
            'user/saveHistoryRouter',
            {
              data: {
                menuPath: path,
                menuName: result.menuName,
                systemId: localStorage.getItem('otherSystemId')
              }
            },
            {
              root: true
            }
          )
        }
      }
    }

    watch(
      () => store.state.app.otherSystemId,
      val => {
        val &&
          val > 0 &&
          store.dispatch('app/GET_USER_PERMISSION', {}, { root: true })
      }
    )
    watch(
      () => route.fullPath,
      () => {
        let path = route.path
        if (path === '/Iframe') {
          path = route.query.target
        } else if (route.fullPath.includes('?')) {
          path = route.fullPath
        }
        state.openKeys = []
        state.selectedKeys = []
        state.favoriteOpenKeys = []
        state.favoriteSelectedKeys = []
        deepFindKeys(path, '', false)
      },
      {
        immediate: true
      }
    )
    // 点击菜单
    const clickMenuItem = (e, type) => {
      const key = e.key
      if (
        key.startsWith('http') &&
        (new URL(key)?.host?.includes('.feishu.cn') ||
          new URL(key)?.host?.includes('.manus.space'))
      ) {
        window.open(key)
        return
      } else {
        deepFindKeys(key, type, true)
      }
    }
    return {
      ...toRefs(state),
      menus,
      favoriteMenus,
      clickMenuItem
    }
  }
}
</script>
<style lang="scss" scoped>
.wrapper {
  min-height: calc(100vh - 88px);
  background: #001529;
  display: flex;
  flex-direction: column;
  padding-bottom: 48px;

  aside {
    width: 100%;
    height: 100%;
    flex: 1 1 0%;

    /* overflow: auto; */
    .router-color {
      a {
        color: white;
      }
    }
    /* &::-webkit-scrollbar {
      width: 5px;
    } */
  }
  .collpased {
    padding: 16px;
    span {
      color: #fff;
      font-size: 18px;
    }
  }
  .menuIcon {
    width: 15px;
    height: 15px;
    display: inline-block;
    margin-right: 5px;
    vertical-align: middle;
    margin-top: -5px;
  }
  .favorite-menu {
    border-bottom: 1px solid #5b5b5b;
  }
}
</style>
